import React from 'react'
import { NextPage } from 'next'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { Box, Heading, SimpleGrid } from '@chakra-ui/react'
import { Head, LinkRel, MetaTags } from 'src/components/common'
import brands from 'src/containers/data/brands.json'
import { getBrandLogoAlt } from 'src/utils/imageAlt'
import { useRouter } from 'next/router'

const BrandsPage: NextPage = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return <Box bgColor="baseBackgroundLight" mt="m">
    <Box maxW="6xl" pt="0" pb="xxl" mx="auto" px="m">
      <Head title={t('nltMarchiPage:title')} />
      <MetaTags meta={t(`nltMarchiPage:meta`, { returnObjects: true })} />
      <LinkRel rel="canonical" href="https://www.carplanner.com/noleggio-lungo-termine-marchi" />

      <Heading as="h1" fontSize="2xl" fontFamily="Montserrat-SemiBold" color="baseDark" textAlign="left">
        {t('nltMarchiPage:title')}
      </Heading>
      <Box
        textAlign="left"
        fontFamily="Montserrat-Regular"
        color="baseDark"
        mb="l"
      >
        {t('nltMarchiPage:description')}
      </Box>

      <SimpleGrid spacing="6" minChildWidth={{ base: '80px', md: '160px' }}>
        {brands.map(brand =>
          <Box
            key={brand.name}
            title={brand.name}
            as="button"
            p={2}
            m={1}
            h={{ base: '120px', md: '150px' }}
            bg="baseWhite"
            rounded="md"
            borderRadius={8}
            borderColor="borders.grey"
            borderWidth="1px"
            textTransform="none"
            _hover={{
              boxShadow: '0 2px 8px 0px rgba(65, 164, 118, 0.12)',
            }}
            color="baseNeutral.700"
            onClick={() => router.push(`/noleggio-a-lungo-termine/${brand.href}`)}
          >
            <Image src={brand.image} alt={getBrandLogoAlt(brand.name)} width="50" height="50" />
            <div>{brand.name}</div>
          </Box>
        )}
      </SimpleGrid>
    </Box>
  </Box>
}

export async function getStaticProps() {
  return { props: {}, revalidate: 60 * 5 }
}

export default BrandsPage
